<template>
  <!-- Base Template -->
  <header>

    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg navbar-light nav-pills">
      <div class="container mb-3">
        <router-link to="/" class="navbar-brand" aria-current="page">Simple Editor</router-link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li v-show="!isAuthenticated" class="nav-item">
              <router-link to="/login" class="nav-link" aria-current="page">Login</router-link>
            </li>
            <li v-show="isAuthenticated" class="nav-item">
              <router-link to="/" class="nav-link" aria-current="page" exact>Projects</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" class="nav-link" aria-current="page">About</router-link>
            </li>
            <li v-show="isAuthenticated" class="nav-item px-3">
              <router-link to="/logout" class="nav-link" aria-current="page">Logout</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

  </header>

  <!-- Router Content -->
  <div class="container">

    <!-- Show Errors -->
    <div v-for="error in errors" :key="error.id" class="error-message alert alert-danger alert-dismissible fade show" role="alert">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
      </svg>
      {{ error.message }}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" @click="removeError(error)"></button>
    </div>

    <!-- Current Router view content -->
    <router-view/>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'

export default {
  methods: {
    removeError(error) {
      this.removeError(error)
    },
    ...mapActions(['login']),
    ...mapMutations(['setUser','removeError'])
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    ...mapState(['errors', 'project'])
  },
  async created() {
    // auto-login on subsequent visits
    if (!this.isAuthenticated && localStorage.auth) {
      let auth = localStorage.auth
      // set auth token in vuex (so other API calls will authenticate)
      this.setUser({auth})
      // auto-login user (to populate vuex user object)
      await this.login(auth)
      if (!this.isAuthenticated) {
        // login failed, show login page
        await this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link.active, .navbar-light .navbar-nav .show>.nav-link {
  color: #ffffff;
}
.error-message {
  text-transform: capitalize;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
